$(document).ready(function () {
    $('[data-bs-toggle="popover"]').each(function () {
        new bootstrap.Popover(this);
    })

    $('a[disabled=""], a[disabled="disabled"]').each(function () {
        $(this).on('click', function (e) {
            e.preventDefault();
        })
    })

    $('.image-link').magnificPopup({
        type:'image'
    });
})
